import styled, { keyframes } from 'vue-styled-components'
import { breakpointStyle } from '../../utils'

const move = keyframes`
  from {
    background-position: 0% 0%;
  }

  to {
    background-position: -400px 0;
  }
`

const StyledUploader = styled.div`
  
  input {
    display: none;
  }
`

const propsLabel = {
  active: Boolean
}

const StyledLabel = styled('label', propsLabel)`
    display: flex;
    justify-content: center;
    align-items: center;
    
    width: 100%;
    height: 48px;
    border: 1px solid ${props => props.theme.colors.disabled};
    background-color: ${props => props.active && props.theme.colors.disabled};
    
    &:hover {
      background-color: ${props => props.theme.colors.disabled};
    }
    
    ${props => breakpointStyle(props.theme.media.desktop, `
      border-style: dashed;
    `)}
`

const StyledText = styled.span`
  margin-left: 8px;
  font-size: 0.875rem;
`

const StyledContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 20px -4px 0;
`

const StyledFile = styled.div`
  display: flex;
  position: relative;
  padding: 4px;
  
  > img, > video {
    height: 120px;
    width: auto;
    max-width: 100%;
    object-fit: cover;
  }
`

const StyledClose = styled.div`
  position: absolute;
  right: 4px;
  top: 4px;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 34px;
  height: 34px;
  cursor: pointer;
  
  &:hover {
    background-color: rgba(34, 34, 34, 0.3);
  }
`

const StyledProgress = styled.div`
  position: relative;
  height: 2px;
  background-color: rgba(34, 34, 34, 0.08);
  margin-top: 20px;
  
  &:after {
    content: '';
    position: absolute;
    left: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 2px;
    background-image: ${props => `linear-gradient(to right, ${props.theme.colors.primary} 0px, ${props.theme.colors.primary} 150px, transparent 150px, transparent 400px, ${props.theme.colors.primary} 400px, ${props.theme.colors.primary} 550px, transparent 800px);`}
    animation: ${move} 2s linear infinite;
  }
`

export {
  StyledUploader,
  StyledLabel,
  StyledText,
  StyledContent,
  StyledFile,
  StyledClose,
  StyledProgress
}



// WEBPACK FOOTER //
// ./src/components/Uploader/StyledUploader.js